export function generateUUID(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const getVisitorId = () => localStorage.getItem("BICYCLE_AI_VISITOR_ID") || generateUUID();
export const setVisitorId = (id: string) => localStorage.setItem("BICYCLE_AI_VISITOR_ID", id);
